import React from 'react';
import { MessageBox as MessageBoxComponent } from '../../components';
import { useAppContext } from '../../context/AppState.jsx';

export default function MessageBox() {
	const [state] = useAppContext();
	const message = state.getMessage;

	if (!message) {
		return null;
	}

	return <MessageBoxComponent message={message} />;
}
